<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('fulfillment_ptl_prepare.prepare_orders') }} </h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-row class="px-0 py-0 mb-1" justify="center" align="center" >
                        <v-col cols="4" justify="center" align="center" class="px-1 py-1" style="text-align: left; background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                            {{ $t('fulfillment_ptl_prepare.product') }}
                        </v-col>
                        <v-col cols="1" justify="center" align="center" class="px-1 py-1" style="text-align: center; background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                            {{ $t('fulfillment_ptl_prepare.location') }}
                        </v-col>
                        <v-col cols="2" justify="center" align="center" class="px-1 py-1" style="text-align: center; background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                            {{ $t('fulfillment_ptl_prepare.batch') }}
                        </v-col>
                        <v-col cols="1" justify="center" align="center" class="px-1 py-1" style="text-align: center; background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                            {{ $t('fulfillment_ptl_prepare.reference') }}
                        </v-col>
                        <v-col cols="1" justify="center" align="center" class="px-1 py-1" style="text-align: center; background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                            {{ $t('fulfillment_ptl_prepare.box') }}
                        </v-col>
                        <v-col cols="1" justify="center" align="center" class="px-1 py-1" style="text-align: center; background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                            {{ $t('fulfillment_ptl_prepare.pallet') }}
                        </v-col>
                        <v-col cols="1" justify="center" align="center" class="px-1 py-1" style="text-align: center; background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                            {{ $t('fulfillment_ptl_prepare.supplied') }}
                        </v-col>
                    </v-row>
                    <span v-for="(product, i) of products" :key="i">
                        <v-row class="px-1 py-2" justify="center" align="center" >
                            <v-col cols="4" justify="center" align="center" class="px-0 py-1" style="border-bottom: 1px solid black; text-align: left;">
                                <v-icon small :class="product.color != 'accent' ? '' : 'material-icons-outlined'" :color="product.color"> fiber_manual_record </v-icon>{{ product.description }}
                            </v-col>
                            <v-col cols="1" justify="center" align="center" class="px-0 py-1" style="border-bottom: 1px solid black;">
                                {{ product.location }}
                            </v-col>
                            <v-col cols="2" justify="center" align="center" class="px-0 py-1" style="border-bottom: 1px solid black;">
                                {{ product.batch ?? "-" }}
                            </v-col>
                            <v-col cols="1" justify="center" align="center" class="px-0 py-1" style="border-bottom: 1px solid black;">
                                {{ product.reference ?? "-" }}
                            </v-col>
                            <v-col cols="1" justify="center" align="center" class="px-0 py-1" style="border-bottom: 1px solid black;">
                                {{ product.box }}
                            </v-col>
                            <v-col cols="1" justify="center" align="center" class="px-0 py-1" style="border-bottom: 1px solid black;">
                                {{ product.pallet }}
                            </v-col>
                            <v-col cols="1" justify="center" align="center" class="px-0 py-1" style="border-bottom: 1px solid black;">
                                {{ product.discount }} / {{ product.total }}
                                <v-icon v-if="product.discount == product.total" class="material-icons-outlined" small color="green" >check_circle</v-icon>
                            </v-col>
                        </v-row>
                    </span>
                    <br>
                    <br>
                    <v-row class="px-5 py-0" justify="center" align="center">
                        <v-col class="px-0 mx-0" cols="8" justify="end" align="end">
                            <v-row justify="end" align="end">
                                <v-btn class="mx-3" outlined color="secondary" @click="cancel()">
                                    {{ $t('fulfillment_ptl_prepare.cancel') }}
                                </v-btn>
                                <v-btn class="right white_highlight--text" :disabled="!all_scanned" color="secondary" @click="save">
                                    {{ $t('fulfillment_ptl_prepare.save') }}
                                </v-btn> 
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>
        <v-dialog v-model="alert_modal" persistent max-width="90%">
            <v-card >
                <v-card-title class="justify-center">
                    <v-row align="center" justify="center">
                        <h3 class="text-uppercase" style="color: var(--v-blue_accent-base);">
                            {{ $t('fulfillment_ptl_prepare.' + modal_type) }}
                        </h3>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row align="center" justify="center" class="py-3 my-3 text-center">
                        <v-col cols="12">
                            <h4>{{ $t('fulfillment_ptl_prepare.' + modal_type + '_message') }} {{ previous_product }}</h4>
                        </v-col>
                    </v-row>
                    
                    <div class="d-flex" style="justify-content: center;">
                        <v-btn color="warning" class="white_highlight--text" @click="closeModal">
                            {{ $t('fulfillment_ptl_prepare.accept') }}
                        </v-btn>
                    </div>
                </v-card-text> 
                <div class="marker2"></div>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>
import { HttpShipmentRepository } from '../../infrastructure/shipment_repository';
import { ptlPrepareOrdersUseCase } from '../../application/use_cases/ptl_prepare_orders_use_case';
import { ptlReleaseOrdersUseCase } from '../../application/use_cases/ptl_release_orders_use_case';
import { ptlConfirmOrdersUseCase } from '../../application/use_cases/ptl_confirm_orders_use_case';

export default {
    computed: {
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            barcode: "",
            last: false,
            order_ids: [],
            products: [],
            alert_modal: false,
            modal_type: '',
            previous_product: "",
            orders_code: "",
            current_location_barcode: "",
            all_scanned: false,
            product_from_correct_location: false,
            shipping_service: this.$route.params.shipping_service,
        }
    },
    mounted(){
        let self = this; 
        const leaveHandler = (e) => { 
            e.preventDefault();
            e.returnValue = '';
        };

        const keyPressHandler = (e) => {
            if(self.last == true && /^\S+$/.test(e.key)) { 
                self.barcode = e.key;
                self.last = false;
            }
            else if(e.code == "Enter") {
                self.last = true;
                self.updateList();
            }
            else if(/^\S+$/.test(e.key)) self.barcode += e.key;
        };

        window.addEventListener('beforeunload', leaveHandler, { capture: true });
        window.addEventListener ('keypress', keyPressHandler, { capture: true });
        
        this.$once('hook:beforeDestroy',
            () => window.removeEventListener('beforeunload', leaveHandler)
        );
        this.$once('hook:beforeDestroy',
            () => window.removeEventListener('keypress', keyPressHandler)
        );

        this.index();
    },
    methods: {
        async index(){
            if(this.$store.state.ffPtlPendings != undefined && this.$store.state.ffPtlPendings != null){
                this.$store.state.ffPtlPendings.forEach(x => {
                    this.order_ids.push(x.id);
                })

                try {
                    const res = await ptlPrepareOrdersUseCase({shipments: this.order_ids}, HttpShipmentRepository);
                    
                    this.orders_code = res.trace_id;
                    this.$store.state.ptl_trace_id = res.trace_id;
                    this.$store.state.ptl_trace_id_loaded = true;

                    res.products.forEach(x => {
                        x.locations.forEach(y => {
                            this.products.push({
                                description: x.description,
                                location: y.location,
                                total: y.discount,
                                discount: 0,
                                barcode: x.barcode,
                                color: "accent",
                                batch: y.batch == null ? "-" : y.batch,
                                box: y.box,
                                location_barcode: y.barcode,
                                reference: y.reference,
                                pallet: y.pallet
                            });
                        });
                    });

                    this.products = this.products.sort((a, b) => a.location_barcode.localeCompare(b.location_barcode))
                }
                catch(e){
                    console.log(e.response);
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: e.response == null? e : e.response.data.fault.message
                    }
                }
            }
            else {
                this.$store.state.loaderProps.visible = false;

                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: "Not order found"
                }
            }
        },
        methodHandler(object){
            this[object.methodName](object.parameters);
        },
        async save(){
            try {
                const res = await ptlConfirmOrdersUseCase(this.orders_code, HttpShipmentRepository);
                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: res.data.success.message
                }
                
                this.orders_code = null;
                this.$store.state.ptl_trace_id = null;
                this.$store.state.ptl_trace_id_loaded = false;
                
                this.$router.go(-1);
            }
            catch(e){
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        closeModal(){
            this.alert_modal = false;
        },
        updateList(){
            let found = false; // product
            let discounted = false; // product discount
            let all_are_scanned = true;
            this.product_from_correct_location = false;
            let is_location = false;
            let is_product = false;
            let all_scanned_from_location = true;
            this.barcode = this.barcode.toString().replaceAll("Enter", "");

            this.products.forEach(x => {
                x.color = "accent";
                
                if(discounted == true) return;
                
                if(x.location_barcode.toLowerCase() == this.barcode.toString().toLowerCase()){
                    x.color = 'blue';
                    this.current_location_barcode = this.barcode.toString().toLowerCase();
                    is_location = true;
                    return;
                }
                else if(x.barcode.toLowerCase() == this.barcode.toString().toLowerCase() && this.current_location_barcode.toLowerCase() == x.location_barcode.toLowerCase()){
                    found = true;
                    this.product_from_correct_location = true;

                    if(x.discount < x.total){
                        x.color = 'green';
                        x.discount++;
                        discounted = true; 
                        
                        is_product = true;
                    }

                    return;
                } 
                else if(x.barcode.toLowerCase() == this.barcode.toString().toLowerCase() && this.current_location_barcode.toLowerCase() != x.location_barcode.toLowerCase()){
                    found = true;
                    this.product_from_correct_location = false;
                    is_product = true;
                    
                    return;
                }
            });

            // All products of list 
            this.products.forEach( x => {
                if(x.discount < x.total) {
                    all_are_scanned = false;
                    return;
                }
            });

            // No location scanned
            if(this.current_location_barcode == "") {
                this.modal_type = "not_expected_location";
                this.alert_modal = true;
                return;
            }

            if(this.current_location_barcode == "" || (!is_product && !is_location)) {
                this.modal_type = "not_expected_location";
                this.alert_modal = true;
                return;
            }

            // Product in list but not in the scanned location
            if((found && !this.product_from_correct_location && is_product)){
                this.modal_type = "incorrect_product";
                this.alert_modal = true;
                return;
            }

            if((!found && !is_product && !is_location)){
                this.modal_type = "not_expected_product";
                this.alert_modal = true;
                return;
            }

            if(discounted == false && found && this.product_from_correct_location){
                this.modal_type = "excedent"
                this.alert_modal = true;
                return;
            }

            // Only products from location
            this.products.forEach( x => {
                if(x.location_barcode.toString().toLowerCase() == this.current_location_barcode.toString().toLowerCase()){
                    if(x.discount < x.total) all_scanned_from_location = false;
                }
            });

            if(all_scanned_from_location == true) this.current_location_barcode = "";
            this.all_scanned = all_are_scanned;
        },
        async cancel(){
            try {
                const res = await ptlReleaseOrdersUseCase(this.orders_code, HttpShipmentRepository);
                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: res.data.success.message
                }
                this.orders_code = null;
                this.$store.state.ptl_trace_id = null
                this.$store.state.ptl_trace_id_loaded = false;
                
                this.$router.go(-1);
            }
            catch(e){
                console.log(e.response);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
    },
    watch:{
        '$route.params.shipping_service': function() {
            location.reload();
        }
    }
}
</script>

<style lang="css">
</style>